import { now, parseAbsolute, parseZonedDateTime, ZonedDateTime } from '@internationalized/date';

export function resolveStoreTimeZone(timezoneName: string | undefined): string {
	const trimmed = timezoneName?.trim();
	if (!trimmed) {
		return 'UTC';
	}

	try {
		Intl.DateTimeFormat('en-US', { timeZone: trimmed });

		return trimmed;
	} catch {
		return 'UTC';
	}
}

export function ensureAbsoluteIso(dateStr: string): string {
	const cleaned = dateStr.replace(/\[.*]$/, '').trim();
	if (/Z$/i.test(cleaned) || /[+-]\d{2}:\d{2}$/.test(cleaned) || /[+-]\d{4}$/.test(cleaned)) {
		return cleaned;
	}

	return `${cleaned}Z`;
}

export function parseConfigToZoned(dateStr: string | undefined, storeTimeZone: string): ZonedDateTime | null {
	if (!dateStr) {
		return null;
	}

	if (dateStr.includes('[') && dateStr.includes(']')) {
		try {
			return parseZonedDateTime(dateStr);
		} catch {
			return null;
		}
	}

	try {
		return parseAbsolute(ensureAbsoluteIso(dateStr), storeTimeZone);
	} catch {
		return null;
	}
}

export function storeNow(storeTimeZone: string): ZonedDateTime {
	return now(storeTimeZone);
}
